import {useRecoilValue} from "recoil";
import {responsiveState} from "../modules/_common/states/UtilStates";

const useResponsive = (size = "md") => useRecoilValue(responsiveState(size));

export default useResponsive;
